import React, {Component} from 'react';
import {connect} from 'react-redux';
import './RecentDevices.scss';
import _ from 'lodash';
import moment from 'moment';
import {downloadView} from '../LeftPane/LeftPane';
import getStatsConfig from '../../Layouts/config/statsConfig';
import {dateFormat} from '../../constants/constants';
import ReactDOM from 'react-dom';
import VehicleAPIs from '../../APIs/VehicleAPIs';
import {JSONToCSVConvertor} from '../../../src/helpers/helperFunctions'
import actions from '../../store/actions';
let statsConfig = getStatsConfig();

let filterItems = (state) => {
    return (f, i) => {
        let filter1 = () => {
            let threshold = moment().valueOf() - state.days * 24 * 60 * 60 * 1000;
            let bindData = state ? state.bindData : null
            if(bindData){
                for(let idx in bindData){
                    let length = bindData[idx].length
                    if(f.vehicleid == parseInt(idx) ){
                        if( length > 1){
                            f.bindtime = bindData[idx][0].time
                            return f.type == 'vehicle' && bindData[idx][length-1].time >= threshold 
                        }else {
                            f.bindtime = bindData[idx][0].time
                            return f.type == 'vehicle' && bindData[idx][0].time >= threshold;
                        }
                    }
                }
            }
        }
        let filter2 = () => {
            let f1 = () => {
                let val = _.get(f, ftypes[state.ftype]);
                let threshold = state.interval * 60 * 60 * 1000;
                return val && val < moment().valueOf() - threshold;
            }
            let f2 = () => {
                let battery = _.get(f, 'stats.carbattery');
                return state.btgt ? battery >= state.battery : battery <= state.battery;
            }
            let f3 = () => {
                let bindData = state ? state.bindData : null;
                if(bindData){
                    for(let idx in bindData){
                        if(f.vehicleid == parseInt(idx)){
                            f.bindtime = bindData[idx][0].time
                            return f.type == 'vehicle'
                        }
                    }
                }
            }
            if(state.ccondition) return f1() && f2();
            else return f1() && f2() && f3();
        }
        if(state.ccondition) return filter1() && filter2();
        else return filter2();
    }
}

let columns = [
    {label: 'Sl No', key: 'slno'},
    {label: 'Vehicle No', key: 'vehicleno'},
    // {label: 'OBD/GPS', key: 'devices.TRACKER.deviceno'},
    // {label: 'GPS Last Comm', key: 'stats.gpstime', trans: time => moment(time).format(dateFormat)},
    // {label: 'CAN Last Comm', key: 'stats.cantime', trans: time => moment(time).format(dateFormat)},
    // {label: 'KLE', key: 'devices.LOCK_UNLOCK.deviceno'},
    // {label: 'KLE Last Comm', key: 'stats.kletime', trans: time => moment(time).format(dateFormat)},
    // {label: 'Vehicle Battery', key: 'stats.carbattery'},
    {label: 'Group', key: 'gno'},
    {label: 'Bind Time', key: 'bindtime', trans: bindtime => moment(bindtime).format(dateFormat)},
    {label: 'Unbind Time', key: 'unbindtime', trans: unbindtime => moment(unbindtime).format(dateFormat)}
]

let ftypes = {
    'GPS': 'stats.gpstime',
    'CAN': 'stats.cantime',
    'KLE': 'stats.kletime',
}

class Dropdown extends Component {
    state = {show:false}
    componentDidMount() {
        document.addEventListener('click', this.onClick);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onClick);
    }
    onClick = e => {
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            this.setState({show:false});
        }
    }
    change = f => {
        this.props.onChange(f);
        this.setState({show:false});
    }
    toggle = e => this.setState({show:!this.state.show});
    render() {
        return (
            <div className="ddwn">
                <button className="ddwn-btn" onClick={this.toggle}>{this.props.value}</button>
                <div className={'ddwn-lst' + (this.state.show ? ' show' : '')}>
                    {this.props.items.map(f => {
                        return <div className="ddwn-itm" key={f}>
                            <button onClick={() => this.change(f)}>{f}</button>
                        </div>
                    })}
                </div>
            </div>
        )
    }
}

class RecentDevices extends Component {
    state = {
        items: 0,
        days: 45,
        interval: 0,
        sort: {
            col: '',
            desc: false
        },
        nokle: false,
        nocan: false,
        ccondition: true,
        ftype: 'GPS',
        btgt: true,
        battery: 0,
        loading: false,
        filled: false,
        bindData: [],
        negativeValue: false
    }
    init = false
    componentDidMount() {
        let items = _.filter(this.props.vehicleMap, v => v.type == 'vehicle');
        let nokle = items.filter(f => 'LOCK_UNLOCK' in f.devices).length == 0;
        if(nokle) columns = columns.slice(0, 5).concat(columns.slice(7));
        let nocan = items.filter(f => _.get(f, 'vehiclemeta.installation_type', '').indexOf('OBD') > -1).length == 0;
        if(nocan) columns = columns.slice(0, 5).concat(columns.slice(6));
        this.setState({nokle,nocan});
        let groupInfo = window.userGroups ? window.userGroups[0] : null
        let  groupid = groupInfo ? groupInfo.groupid : null
        const auth = window.getAuth();
        if(groupid){
            let body = {
                "token" : auth.token,
                "groupid" : groupid
            }
            // VehicleAPIs.getBindDate(body)
            //  .then(resp =>{
            //     this.setState({
            //         bindData: resp
            //     })
            //   })
        }
    }
    componentWillReceiveProps(props) {
        if(props.recentDevices) {
            if(!this.state.filled) {
                // this.busyTable();
                setTimeout(() => this.drawTable(), 500);
            }
        } else {
            if(this.state.filled) this.clearTable();
        }
    }
    download = () => {
        let downloadData = []
        this.state.bindData.map((data,index) => {
            let tempObj = {}
            tempObj = {
            VehicleNo : data.vehicleno,
            DeviceId : data.did,
            Group: data.gno,
            BindTime: data.bindtime,
            UnbindTime: data.unbindtime
           }
           downloadData.push(tempObj)
        })
        JSONToCSVConvertor(downloadData, "ViewReport", true);
        // let vehicleMap = _.pickBy(this.props.vehicleMap, this.getFilter());
        // let vehicles = this.state.sortedVehicles
        // downloadView(this.props.stats.allvehicles, vehicles, statsConfig,this.props.groupTree,this.props.recentDevices);
    }
    getFilter = () => {
        let state = _.pick(this.state, ['ccondition', 'btgt', 'battery', 'interval', 'days', 'ftype','bindData']);
        return filterItems(state);
    }
    getFilteredItems = () => {
        let {sort} = this.state;
        let items = _.filter(this.props.vehicleMap, this.getFilter());
        this.setState({
            sortedVehicles: items
        })
        if(sort.col) items = _.orderBy(items, [sort.col], [sort.desc && 'desc']);
        return items.map((f, i) => {
            return columns.map(c => {
                let val = _.get(f, c.key);
                if(val && c.trans) val = c.trans(val);
                return c.key ? (val || 'N/A') : (i + 1);
            })
        });
    }
    clearTable = () => {
        let el = ReactDOM.findDOMNode(this);
        let tbody = el.querySelector('tbody');
        tbody.innerHTML = '';
        this.setState({filled:false});
        return tbody;
    }
    busyTable = () => {
        let el = ReactDOM.findDOMNode(this);
        let tbody = el.querySelector('tbody');
        tbody.innerHTML = `<tr><td colspan=${columns.length}><div class="dual-ring"><div></div></div></td></tr>`;
    }
    drawTable = () => {
        // if(!this.state.battery) this.setState({battery: 0})
        // if(!this.state.interval) this.setState({interval: 0})
        // if(this.state.loading) return;
        // this.setState({loading:true, negativeValue : false});
        // if(this.state.battery !== 0 && Math.sign(this.state.battery) === -1){
        //     this.setState({negativeValue : true})
        // }
        // if(this.state.interval !==0 &&Math.sign(this.state.interval) === -1 ) this.setState({negativeValue : true})
        setTimeout(() => {
            let el = ReactDOM.findDOMNode(this);
            let tbody = el.querySelector('tbody');
            tbody.innerHTML = '';
            let html = '';
            // let data = this.getFilteredItems();
            let data = this.state.bindData
            data.forEach(f => {
                let cols = columns.map(c => '<td>' + f[c.key] + '</td>').join('');
                html += '<tr>' + cols + '</tr>';
            })
            // if(this.state.negativeValue) html = `<div class="no-data">NO DATA</div>`
            // if(!this.state.bindData.length) html = `<div class="no-data">NO DATA</div>`
            tbody.innerHTML = html;
            this.setState({items:data.length,loading:false,filled:true});
        }, 50);
    }
    
    updateDays = e => {
        let days = e.target.value;
        this.setState({days});
    }
    getBindData = event => {
        if(event.keyCode === 13) {
            this.fetchBindData()
        }
    }
    updateHrs = e => {
        let interval = e.target.value;
        this.setState({interval});
    }
    sortCol = col => {
        if(this.state.loading) return;
        let sort = {col: this.state.sort.col,desc:false}
        if(col) {
            if(this.state.sort.col == col) sort.desc = !this.state.sort.desc;
            else sort.col = col;
        }
        this.setState({sort}, this.drawTable);
    }
    mapColumnHeads = c => {
        let sortbtn = () => {
            let icon = 'fa fa-sort';
            if(this.state.sort.col == c.key) icon += (this.state.sort.desc ? '-up' : '-down');
            return <button><i className={icon}></i></button>;
        }
        // return <th key={c.key} onClick={e => this.sortCol(c.key)}><span>{c.label}</span> {c.key && sortbtn()}</th>
        return <th key={c.key} ><span>{c.label}</span>
        </th>
    }
    changeBattery = e => {
        this.setState({battery:e.target.value});
    }
    // fetchBindData = () => {
    //     console.log("groupTree",this.props.groupTree);
    //     const groupIds = this.props.groupTree.children.map(child => child.groupid);
    //     console.log("groupId",groupIds);
        
        
    //     this.setState({loading : true})
    //     let processedData = []
    //     let starttime = moment().valueOf() - this.state.days * 24 * 60 * 60 * 1000;
    //     let groupInfo = window.userGroups ? window.userGroups[0] : null
    //     let  groupid = groupInfo ? groupInfo.groupid : null
    //     let body = {
    //         starttime: starttime,
    //         groupid: groupid
    //     }
    //     VehicleAPIs.getBindDate(body)
    //         .then(resp =>{
    //             let slno = 1
    //             for(let idx in resp) {
    //                 let bindData = resp[idx]
    //                 bindData.map((bind_data) => {
    //                     let tempObj = {}
    //                     tempObj.vehicleno = idx
    //                     tempObj.gno = bind_data.gno
    //                     tempObj.type = bind_data.type
    //                     tempObj.did = bind_data.did
    //                     tempObj.bindtime = bind_data.bindtime ? moment(bind_data.bindtime).format(dateFormat) : ""
    //                     tempObj.unbindtime = bind_data.unbindtime ? moment(bind_data.unbindtime).format(dateFormat) : ""
    //                     tempObj.slno = slno++
    //                     processedData.push(tempObj)
                        
    //                 })
    //                 // if(resp[idx].length) {
    //                 //     if(resp[idx].length > 1){
    //                 //         let firstBindTime = resp[idx][0].bindtime
    //                 //         let oldestObj = resp[idx][0]
    //                 //         resp[idx].map((bind_data) => {
    //                 //             if(bind_data.time < firstBindTime){

    //                 //                 oldestObj = bind_data
    //                 //                 firstBindTime = bind_data.bindtime
    //                 //                 bind_data.vehicleno = idx
    //                 //                 bind_data.bindtime = bind_data.bindtime ? moment(bind_data.time).format(dateFormat) : "NA"
    //                 //                 // bind_data.slno = slno++
    //                 //             }
    //                 //         })
    //                 //         if(oldestObj.vehicleno === undefined) {
    //                 //             oldestObj.vehicleno = idx
    //                 //             oldestObj.bindtime = oldestObj.bindtime ? moment(oldestObj.bindtime).format(dateFormat) : "NA"
    //                 //             oldestObj.unbindtime = oldestObj.unbindtime ? moment(oldestObj.unbindtime).format(dateFormat) : "NAs"
    //                 //             // oldestObj.slno = slno++
    //                 //         }
    //                 //         oldestObj.slno = slno++
    //                 //         processedData.push(oldestObj)

    //                 //     }
    //                 //     else{
    //                 //         resp[idx].map((bind_data,index) => {
    //                 //             bind_data.vehicleno = idx
    //                 //             bind_data.bindtime = bind_data.bindtime ?  moment(bind_data.bindtime).format(dateFormat) : "NA"
    //                 //             bind_data.unbindtime = bind_data.unbindtime ? moment(bind_data.unbindtime).format(dateFormat) : "na"
                                
    //                 //             bind_data.slno = slno++
    //                 //             processedData.push(bind_data)
    //                 //         })
    //                 //     }

    //                 // }
    //             }
    //             this.setState({
    //                 bindData: processedData,
    //                 loading: false
    //             })
    //             this.drawTable()
    //         })
    //         .catch (e => {
    //             this.setState({loading: false})
    //             let errorMsg = e.response.data.msg
    //             this.props.dispatch({
    //                 type:actions.ADD_INTOAST,
    //                 data:{
    //                     name:"Installation info fetching is failed.",
    //                     content:errorMsg, 
    //                     createAt:Date.now()
    //                 }
    //             });
    //         })
    // }
    fetchBindData = () => {
        const groupIds = this.props.groupTree.children
            .map(child => child.groupid)
            .filter(id => id !== 0);
    
        if (groupIds.length === 0) {
            console.log("No Group Found");
            return;
        }
    
        this.setState({ loading: true });
    
        let processedData = [];
        let starttime = moment().valueOf() - this.state.days * 24 * 60 * 60 * 1000;
    
        // Create API calls for each groupId
        const apiCalls = groupIds.map(groupid => {
            let body = { starttime, groupid };
            return VehicleAPIs.getBindDate(body)
                .then(resp => ({ groupid, resp }))
                .catch(e => {
                    // console.error(`Error fetching data for group ${groupid}:`, e);
                    return null; // Skip failed call
                });
        });
    
        Promise.all(apiCalls).then(results => {
            let slno = 1;
            results.forEach(result => {
                if (!result) return; // Skip failed responses
    
                const resp = result.resp;
    
                for (let idx in resp) {
                    let bindData = resp[idx];
                    bindData.forEach(bind_data => {
                        let tempObj = {};
                        tempObj.vehicleno = idx;
                        tempObj.gno = bind_data.gno;
                        tempObj.type = bind_data.type;
                        tempObj.did = bind_data.did;
                        tempObj.bindtime = bind_data.bindtime ? moment(bind_data.bindtime).format(dateFormat) : "";
                        tempObj.unbindtime = bind_data.unbindtime ? moment(bind_data.unbindtime).format(dateFormat) : "";
                        tempObj.slno = slno++;
                        processedData.push(tempObj);
                    });
                }
            });
    
            this.setState({
                bindData: processedData,
                loading: false
            });
    
            this.drawTable();
        }).catch(e => {
            this.setState({ loading: false });
            let errorMsg = e.response?.data?.msg || "Unknown error";
            this.props.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: "Installation info fetching failed.",
                    content: errorMsg,
                    createAt: Date.now()
                }
            });
        });
    };
    
    render() {
        let otherProps = {};
        return (
            <div className={"RecentDevices " + (this.props.recentDevices && !this.props.reportWindow.visible && !this.props.tableView.active ? ' active ':'')} {...otherProps}>
                <div className="rw-c">
                    <div className="rw-ct">
                        <div className="rw-tt rw-tx">
                            <div className="rw-tl">
                                <div className="rw-ttl">
                                    {/* Total : {this.state.items} */}
                                     installations done in last <input type="number"  min={1} value={this.state.days} onKeyDown={this.getBindData} onChange={this.updateDays}/> days
                                </div>
                                <div className="rw-ttr">
                                    <button onClick={() => this.fetchBindData()}>{this.state.loading ? <i className="fa fa-refresh fa-spin"></i> : 'Fetch'}</button>
                                    {/* <button onClick={() => this.setState({ccondition: !this.state.ccondition})}>{this.state.ccondition ? 'AND' : 'OR'}</button> */}
                                </div>
                            </div>
                            <div className="rw-tr">
                                <button onClick={this.download}><i className="fa fa-download"></i></button>
                            </div>
                        </div>
                        {/* <div className="rw-tt rw-ty">
                            <div className="rw-tl">
                                <div className="rw-tbl">
                                    <Dropdown items={Object.keys(ftypes)} value={this.state.ftype} onChange={(ftype) => this.setState({ftype})} />
                                    <span>
                                        Non communicating since <input type="number" value={this.state.interval} onChange={this.updateHrs} /> hrs
                                    </span>
                                </div>
                            </div>
                            <div className="rw-tr">
                                <div className="rw-tyl">
                                    Battery
                                    <button onClick={() => this.setState({btgt:!this.state.btgt})}>{this.state.btgt ? '>=' : '<='}</button>
                                    <input type="number" value={this.state.battery} onChange={this.changeBattery} />
                                </div>
                                <div className="rw-tyr">
                                    <button onClick={this.drawTable}>{this.state.loading ? <i className="fa fa-refresh fa-spin"></i> : 'OK'}</button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="rw-ci">
                        <table className="rw-tb">
                            <thead style={{position:"sticky", top:0, background:"rgb(228 226 226)", height:34}}><tr>
                                {columns.map(this.mapColumnHeads)}
                            </tr></thead>
                            <tbody>
                            </tbody>
                        </table>
                        {!this.state.bindData.length && <div className='no-dataa'>
                        NO DATA
                    </div>}
                    </div>
                    
                    
                </div>
            </div>
        )
    }
}

const mapPropsToState = state => {
    return {
        recentDevices:state.recentDevices,
        reportWindow:state.reportWindow,
        tableView:state.tableView,
        vehicleMap:state.vehicleMap,
        stats:state.stats,
        gotAllBuckets:state.gotAllBuckets,
        groupTree: state.groupTree,
    };
};


export default connect(mapPropsToState)(RecentDevices);